import type { AdminNamespace } from '@cli-types/next-adapter/config.js'

export function replaceAdminScreamingToken(value: string, namespace: AdminNamespace): string {
  return value.replaceAll('ADMIN_', `${namespace.screaming}_`)
}
